import { useContext, useEffect, useRef, useState } from "react";
import { Button, Collapse, Dropdown, Form, Modal, OverlayTrigger } from "react-bootstrap";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { withTranslation } from "react-i18next";
import { BiDownload, BiUpload } from "react-icons/bi";
import { BsFilter, BsLayoutSplit, BsList, BsTable } from "react-icons/bs";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { LoaderContext, RegulationContext } from "../../../../App";
import FinalizeConfigurationModal from "../../../../components/FinalizeConfigurationModal/FinalizeConfigurationModal";
import FinalizeProgressLoader from "../../../../components/FinalizeProgressLoader/FinalizeProgressLoader";
import { DataViewCategoryType } from "../../../../core/constants/common";
import useFinalizeStatusPoller from "../../../../core/hooks/useFinalizeStatusPoller";
import useHasPermission from "../../../../core/hooks/useHasPermission";
import StandardService from "../../../../core/service/StandardService";
import Utils from "../../../../core/utilities/Utils";
import CollapsibleGeneralDisclosures from "../../Disclosures/CollapsibleGeneralDisclosures";
import AddTopic from "../AddTopic/AddTopic";
import CreateDataPoint from "../CreateDataPoint/CreateDataPoint";
import CreateMetric from "../CreateMetric/CreateMetric";
import StandardsCreate from "../StandardsCreate/StandardsCreate";
import StandardsFilter from "../StandardsFilter/StandardsFilter";
import Topics from "../Topics/Topics";
import TopicsMetricsDpsTable from "../TopicsMetricsDpsTable/TopicsMetricsDpsTable";
import "./StandardsMain.scss";

const StandardsMain = ({ t, listObj, handleChildToggle, parent, sType, setChild }) => {
  let lsData = JSON.parse(localStorage.getItem("authority"));
  const [showTopic, setShowTopic] = useState(false);
  const [editTopicId, setEditTopicId] = useState("");
  const [shown, setShown] = useState({});
  const [openStandardSave, setOpenStandardSave] = useState(false);
  const [editStandardItem, setEditStandardItem] = useState({});
  const [stdId, setStdId] = useState("");
  const [type, setType] = useState(sType);
  const [data, setData] = useState([]);
  const [list, setList] = useState(listObj);
  const [showMetric, setShowMetric] = useState(false);
  const [topicId, setTopicId] = useState("");
  const [editMetricId, setEditMetricId] = useState("");
  const [showDataPoints, setShowDataPoints] = useState(false);
  const [metricId, setMetricId] = useState("");
  const [categorydata, setCategoryData] = useState([]);
  const [shownInside, setShownInside] = useState({});
  const [currentDs, setCurrentDs] = useState([]);
  const [currentcategory, setCurrentCategory] = useState(null);
  const [editDataPointId, setEditDataPointId] = useState("");
  const [editdata, setEditData] = useState(null);
  const [equation, setEquation] = useState(null);
  const { glbRegulation } = useContext(RegulationContext);
  const { setLoaderDisplay } = useContext(LoaderContext);
  const [viewMode, setViewMode] = useState("collapse");
  const [showFilter, setShowFilter] = useState(false);
  const [tableData, setTableData] = useState({ topics: [] });
  const [isLoadingTable, setIsLoadingTable] = useState(false);
  const [currentFilter, setCurrentFilter] = useState({
    category: DataViewCategoryType.ENVIRONMENTAL,
    topicIds: [],
    metricIds: [],
    dpIds: [],
  });
  const [colHideShow, setColHideShow] = useState({
    ecdCode: true,
    type: true,
    unit: true,
    possibleUoms: true
  });
  const [showFinalizeModal, setShowFinalizeModal] = useState(false);
  const [showFormCreatedSuccessModal, setShowFormCreatedSuccessModal] = useState(false);
  const { isFinalizeInProgress, triggerPolling } = useFinalizeStatusPoller();
  const { hasConfigUpdatePermission } = useHasPermission();
  const [selectedTopicIds, setSelectedTopicIds] = useState([]);
  const [topicsRefreshKey, setTopicsRefreshKey] = useState(0);
  const topicImportFileRef = useRef(null);
  useEffect(() => {
    setSelectedTopicIds([]);
  }, [glbRegulation?.id]);

  useEffect(() => {
    listObj['socialcount'] = 0
    listObj['environmentcount'] = 0
    listObj['governencecount'] = 0
    setList(listObj);
    localStorage.setItem('standardName', glbRegulation.name);
  }, [listObj, listObj?.status]);

  useEffect(() => {
    if (viewMode === "table" && glbRegulation?.id) {
      fetchTableData(currentFilter);
    }
  }, [viewMode, glbRegulation?.id]);


  const getCategory = async (e) => {
    StandardService.getCategory()
      .then((response) => {
        setCategoryData([...response.data]);
        // filterCategoryData()
      })
      .catch((error) => { });
  };

  const handleExpand = (id, itemType) => {
    getCategory();
    setShowTopic(false);
    setShowMetric(false);
    const newVal = !shown[id];
    var obj = function (shown) {
      Object.keys(shown).forEach(function (key) {
        shown[key] = false;
      });
      return shown;
    };
    setShown({
      ...obj,
      [id]: newVal,
    });
    if (itemType === "STANDARD") {
      getTopics(id);
    }
    else if (itemType === "TOPIC") {
      setTopicId(id);
      getMetric(stdId, id);
    }
    else if (itemType === "METRIC") {
      setMetricId(id);
      getDataPoints(id);
    }
    // else {
    // }
  };
  const getTopics = (stdid) => {
    StandardService.getTopics(stdid)
      .then((response) => {
        setList(response?.data);
        const topics = response?.data?.topics;
        if (Array.isArray(topics)) {
          setData([...topics]);
        } else {
          setData([]);
        }

      })
      .catch((error) => { });
  };

  const getDataPoints = (mId) => {
    StandardService.getDataPoints(mId)
      .then((response) => {
        setList(response?.data.body);
        const dataPoints = response?.data?.body?.dataPoints;
        if (Array.isArray(dataPoints)) {
          setData([...dataPoints]);
        } else {
          setData([]);
        }

      })
      .catch((error) => {
      });
  };

  const handleDiscard = (isDiscard) => {
    setShowTopic(!isDiscard);
    setShowMetric(!isDiscard);
    setShowDataPoints(!isDiscard);
  };
  const handleAfterSave = (id) => {
    if (viewMode === "table") {
      // Refresh table data when in table view
      fetchTableData(currentFilter);
      setShowTopic(false);
    } else {
      // Use existing logic for collapse view
      getTopics(id);
    }
  };
  const handlePublish = (list) => {
    let status = "PUBLISHED";
    StandardService.updateStandardStatus(list.id, status, list)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          var data = {
            standardId: list.id,
            childStatus: "Close",
            type: "STANDARD",
            parent: 0,
          };
          handleChildToggle(data);
        }
      })
      .catch((error) => { });
  };

  const handleFinalizeConfiguration = (payload) => {
    if (!glbRegulation?.id) {
      toast.error(t("Error.label") || "Standard ID is missing", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    setLoaderDisplay(true);
    StandardService.finalizeConfiguration(glbRegulation.id, payload)
      .then((response) => {
        setLoaderDisplay(false);
        if (response.status === 200 || response.status === 201) {
          toast.success(t("FinalizeConfiguration.success.label") || "Form creation initiated successfully", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setShowFinalizeModal(false);
          // Trigger polling; show success popup when form-creation/status API returns complete
          triggerPolling(() => setShowFormCreatedSuccessModal(true));
        } else {
          toast.error(t("FinalizeConfiguration.error.label") || "Failed to finalize configuration", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
        setLoaderDisplay(false);
        const errorMessage = error.response?.data?.message || error.message || t("FinalizeConfiguration.error.label") || "Failed to finalize configuration";
        toast.error(errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const editStandard = (list) => {
    setOpenStandardSave(true);
    setEditStandardItem(list);
  };
  const handleEditCallback = (obj) => {
    setOpenStandardSave(obj.val);
    var data = {
      standardId: list.id,
      childStatus: "Close",
      type: obj.type,
      parent: 0,
    };
    handleChildToggle(data);
  };

  const handleDeleteCallback = (stdid, id, type) => {
    StandardService.deleteTopic(stdid, id)
      .then((response) => {
        if (response.status === 204) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          getTopics(stdid);
        }
      })
      .catch((error) => { });
  };


  const handleDeleteDataPointCallback = (id) => {
    StandardService.deleteDataPoint(id)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          getDataPoints(metricId);
        }
      })
      .catch((error) => { });
  };

  const handleEditTopicCallback = (obj) => {
    setShowTopic(true);
    setStdId(obj.stdId);
    setEditTopicId(obj.id);
  };
  const handleTopicChild = (obj) => {
    setType(obj.type);
    setStdId(obj.stdId);
    getMetric(obj.stdId, obj.id);
    handleExpand(obj.id, obj.type);
    setChild(true, list.id)
  };
  const getMetric = (stdid, topicid) => {
    StandardService.getMetrics(stdid, topicid)
      .then((response) => {
        setData([...response.data.metrics]);
        setList(response.data);
      })
      .catch((error) => { });
  };
  const handleCloseChild = (id) => {
    setShowMetric(false);
    if (type === "TOPIC") {
      setShown({ [stdId]: true });
      setType("STANDARD");
      getTopics(stdId);
    } else if (type === "METRIC") {
      setType("TOPIC");
      getMetric(stdId, id);
      setShown({ [id]: true });
    }
  };
  const handleDeleteMetricCallback = (stdId, metricId, tpcId) => {
    StandardService.deleteMetric(metricId)
      .then((response) => {
        if (response.status === 204) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          getMetric(stdId, tpcId);
        }
      })
      .catch((error) => { });
  };
  const handleEditMetricCallback = (obj) => {
    setShowMetric(true);
    setStdId(obj.stdId);
    setTopicId(obj.topicId);
    setEditMetricId(obj.id);
  };

  const handleEditDataPointCallback = (obj) => {
    setShowDataPoints(true);
    // setStdId(obj.stdId);
    setMetricId(obj.metricId);
    setEditDataPointId(obj.id);
    setEditData(obj.data)
  };

  const handleAfterMetricSave = () => {
    if (viewMode === "table") {
      // Refresh table data when in table view
      fetchTableData(currentFilter);
      setShowMetric(false);
    } else {
      // Use existing logic for collapse view
      getMetric(stdId, topicId);
    }
  }
  const handleAfterDataPointSave = () => {
    if (viewMode === "table") {
      // Refresh table data when in table view
      fetchTableData(currentFilter);
      setShowDataPoints(false);
    } else {
      // Use existing logic for collapse view
      getDataPoints(metricId);
    }
  }
  const handleMetricDiscard = (isDiscard) => {
    setShowTopic(!isDiscard);
    setShowMetric(!isDiscard);
    setShowDataPoints(!isDiscard)
  }
  const handleMetricChild = (obj) => {
    setEquation(obj.equation);
    setType(obj.type);
    setStdId(obj.stdId);
    getDataPoints(obj.id);
    handleExpand(obj.id, obj.type);
  };

  const handleExpandDs = (e, categoryType) => {
    // setCurrentCategory(categoryType);
    // setDsList([]);
    // setCurrentDs([]);
    // currentDs.length = 0;
    // setCurrentDs(currentDs);
    // //setSelDataSource(id);

    const newVal = !shownInside[categoryType];
    if (newVal) {
      let obj = { categoryType: categoryType };
      setCurrentDs([...currentDs, obj]);
    }
    setShownInside({
      [categoryType]: !shownInside[categoryType],
    });
    // console.log('shownInsideshownInside',shownInside)
    //  setIsExpanded(true);
  };

  const handleCount = (categoryObj) => {
    let listdata = list;
    listdata['socialcount'] = categoryObj[0].arrayLength
    listdata['environmentcount'] = categoryObj[1].arrayLength
    listdata['governencecount'] = categoryObj[2].arrayLength
    setList(listdata);
    // console.log('datadata',categoryObj,list)
  }

  const countCalculate = (category) => {
    switch (category) {
      case 'SOCIAL': return list.socialcount
      case 'ENVIRONMENTAL': return list.environmentcount
      case 'GOVERNANCE': return list.governencecount
      default:
        break;
    }
  }

  const handleFilterApply = (filter) => {
    setCurrentFilter(filter);
    fetchTableData(filter);
  };

  const fetchTableData = async (filter) => {
    if (!glbRegulation?.id) return;

    setIsLoadingTable(true);
    try {
      const response = await StandardService.getTopicsMetricsDps(
        glbRegulation.id,
        filter.category,
        filter.topicIds,
        filter.metricIds,
        filter.dpIds
      );
      if (response.status === 200) {
        setTableData(response.data || { topics: [] });
      } else {
        setTableData({ topics: [] });
      }
    } catch (error) {
      setTableData({ topics: [] });
    } finally {
      setIsLoadingTable(false);
    }
  };

  const handleFilterReset = () => {
    const resetFilter = {
      category: DataViewCategoryType.ENVIRONMENTAL,
      topicIds: [],
      metricIds: [],
      dpIds: [],
    };
    setCurrentFilter(resetFilter);
    if (viewMode === "table") {
      fetchTableData(resetFilter);
    } else {
      setTableData({ topics: [] });
    }
  };

  // Helper function to get localized name
  const getLocalizedName = (item) => {
    if (!item) return "";
    if (item.localizedContents && item.localizedContents.length > 0) {
      // Try to find translation for current language, fallback to English, then to name
      const currentLang = localStorage.getItem('i18nextLng') || 'en';
      let translated = item.localizedContents.find(
        content => content.languageCode === currentLang && content.fieldName === 'name'
      );
      if (!translated) {
        translated = item.localizedContents.find(
          content => content.languageCode === 'en' && content.fieldName === 'name'
        );
      }
      if (translated && translated.translatedValue) {
        return translated.translatedValue;
      }
    }
    return item.name || "";
  };

  // Helper function to format UOMs
  const formatRelevantUoms = (uoms) => {
    if (!uoms) return "";
    if (Array.isArray(uoms)) {
      return uoms.join(", ");
    }
    if (typeof uoms === "string") {
      return uoms;
    }
    return String(uoms);
  };

  // Helper function to convert category to sentence case
  const toSentenceCase = (str) => {
    if (!str || typeof str !== "string") return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  // Export table data to Excel
  const handleExportToExcel = () => {
    if (!tableData || !tableData.topics || tableData.topics.length === 0) {
      toast.warning(t("NoDataToExport.label") || "No data available to export", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setLoaderDisplay(true);

    try {
      // Build headers based on visible columns
      const headers = [
        t("Topic.label"),
        t("Metrics.label"),
      ];
      
      if (colHideShow.ecdCode) {
        headers.push(t("ECDCode.label"));
      }
      if (colHideShow.type) {
        headers.push(t("Type.label"));
      }
      if (colHideShow.unit) {
        headers.push(t("Unit.label"));
      }
      if (colHideShow.possibleUoms) {
        headers.push(t("PossibleUOMs.label"));
      }
      
      headers.push(
        t("DataPoints.label"),
        t("AltText.label"),
        t("HelpText.label"),
        t("DataPointCode.label"),
        t("Unit.label"),
        t("PossibleUOMs.label"),
        t("Frequency.label"),
        t("DataOwnerGroup.label"),
        t("Equation.label"),
        t("Emission.label"),
        t("KPI.label"),
        t("LinkToDataSource.label"),
        t("LinkToEMF.label")
      );

      // Flatten the nested structure (topics -> metrics -> datapoints) into rows
      const excelData = [];
      
      tableData.topics.forEach((topic) => {
        const topicName = getLocalizedName(topic);
        
        if (!topic.metrics || topic.metrics.length === 0) {
          // Topic with no metrics
          const row = [topicName, ""];
          if (colHideShow.ecdCode) row.push("");
          if (colHideShow.type) row.push("");
          if (colHideShow.unit) row.push("");
          if (colHideShow.possibleUoms) row.push("");
          row.push("", "", "", "", "", "", "", "", "", "", "", "");
          excelData.push(row);
        } else {
          topic.metrics.forEach((metric) => {
            const metricName = getLocalizedName(metric);
            
            if (!metric.metricDataPoints || metric.metricDataPoints.length === 0) {
              // Metric with no datapoints
              const row = [topicName, metricName];
              if (colHideShow.ecdCode) row.push(metric.code || "");
              if (colHideShow.type) row.push(toSentenceCase(metric.category) || "");
              if (colHideShow.unit) row.push(metric.unitOfMeasure || "");
              if (colHideShow.possibleUoms) row.push(formatRelevantUoms(metric.relevantUoms));
              row.push(
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                metric.equation?.expression || "",
                metric.category === 'QUANTITATIVE' ? (metric.emissionLinked ? "Yes" : "No") : "",
                metric.kpi ? "Yes" : "No",
                "",
                ""
              );
              excelData.push(row);
            } else {
              // Metric with datapoints
              metric.metricDataPoints.forEach((dataPoint) => {
                const dataPointName = getLocalizedName(dataPoint);
                const row = [topicName, metricName];
                
                if (colHideShow.ecdCode) row.push(metric.code || "");
                if (colHideShow.type) row.push(toSentenceCase(metric.category) || "");
                if (colHideShow.unit) row.push(metric.unitOfMeasure || "");
                if (colHideShow.possibleUoms) row.push(formatRelevantUoms(metric.relevantUoms));
                
                row.push(
                  dataPointName,
                  "",
                  "",
                  dataPoint.code || "",
                  dataPoint.unitOfMeasure || "",
                  formatRelevantUoms(dataPoint.relevantUoms),
                  toSentenceCase(dataPoint.frequency || ""),
                  dataPoint.groups ? (Array.isArray(dataPoint.groups) ? dataPoint.groups.join(", ") : String(dataPoint.groups)) : "",
                  "",
                  dataPoint.emission ? "Yes" : "No",
                  metric.kpi ? "Yes" : "No",
                  dataPoint.riskDataSource || dataPoint.datasourceLink ? "Yes" : "No",
                  dataPoint.emissionFactor ? "Yes" : "No"
                );
                excelData.push(row);
              });
            }
          });
        }
      });

      // Create workbook and worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...excelData]);

      // Set column widths for better readability
      const colWidths = headers.map(() => ({ wch: 20 }));
      worksheet['!cols'] = colWidths;

      // Append worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Topics Metrics DataPoints");

      // Generate filename with timestamp
      const fileName = `Topics_Metrics_DataPoints_${new Date().toISOString().split('T')[0]}.xlsx`;

      // Download the file
      XLSX.writeFile(workbook, fileName);

      setLoaderDisplay(false);
      toast.success(t("ExportSuccess.label") || "Data exported successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } catch (error) {
      setLoaderDisplay(false);
      toast.error(t("ExportError.label") || "Error exporting data", {
        position: toast.POSITION.TOP_RIGHT,
      });
      console.error("Export error:", error);
    }
  };

  const downloadTopicsExcelFile = (response, fileName) => {
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileURL = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fileURL;
    link.download = fileName;
    link.click();
    link.remove();
    window.URL.revokeObjectURL(fileURL);
  };

  const handleExportTopics = () => {
    if (!glbRegulation?.id || selectedTopicIds.length === 0) return;

    StandardService.exportTopics(glbRegulation.id, { topicIds: selectedTopicIds })
      .then((response) => {
        downloadTopicsExcelFile(response, `topics_export_${glbRegulation.id}.xlsx`);
      })
      .catch(() => { });
  };

  const handleImportTopicsClick = () => {
    topicImportFileRef.current?.click();
  };

  const handleImportTopicsFile = (e) => {
    const file = e.target.files?.[0];
    if (!file || !glbRegulation?.id) return;

    const formData = new FormData();
    formData.append("file", file);

    setLoaderDisplay(true);
    StandardService.importTopics(glbRegulation.id, formData)
      .then((response) => {
        if (response.status === 200) {
          Utils.showImportResultToast(t, response.data);
          setSelectedTopicIds([]);
          setTopicsRefreshKey((key) => key + 1);
        }
      })
      .catch(() => { })
      .finally(() => {
        setLoaderDisplay(false);
        e.target.value = "";
      });
  };

  const canManageTopicExportImport = () =>
    hasConfigUpdatePermission() && !isFinalizeInProgress;

  return (
    <>
      <div
        className="StandardsMain_listCard"
        id={list?.id}
        key={list?.id}
      >
        <div className='Sub_headerBox mb-2 1'>
          <ul>
            <li>
              {
                viewMode === 'collapse'
                ? <>{t("Name.label")} : <b>{list?.name}</b></>
                : <>{t("Name.label")} : <b>{glbRegulation.name}</b></>
              }              
              {list?.status === "DRAFT" && <small className="ms-2 text-High">({t("DoPublishMessage.label")})</small>}
              <div className="btn-custom p-0 text-end">
                <div className="standards-view-controls d-flex align-items-center gap-2">
                  {viewMode === "table" && (
                    <>
                      <OverlayTrigger
                        overlay={Utils.renderTooltip(
                          t("Filter.label")
                        )}>
                        <button
                          className="btn btn-headbtn"
                          onClick={() => setShowFilter(!showFilter)}
                          aria-label={t("Filter.label")}
                        >
                          <BsFilter />
                        </button>
                      </OverlayTrigger>
                      <OverlayTrigger
                        overlay={Utils.renderTooltip(
                          t("ShowColumns.label")
                        )}>
                        <Dropdown>
                          <Dropdown.Toggle variant="headbtn" id="dropdown-basic">
                            <BsLayoutSplit />
                          </Dropdown.Toggle>

                          <Dropdown.Menu className="CustomizeColumns_drop p-2">
                            <div className="p-2">
                              <h6 className="mb-0">{t("ShowColumns.label")}</h6>
                            </div>
                            <ul>
                              <li>
                                <Form.Check
                                  inline
                                  name="group1"
                                  label={t("ECDCode.label")}
                                  type="checkbox"
                                  id="inline-checkbox-ecd"
                                  checked={colHideShow.ecdCode}
                                  onChange={() => setColHideShow({ ...colHideShow, ecdCode: !colHideShow.ecdCode })}
                                />
                              </li>
                              <li>
                                <Form.Check
                                  inline
                                  name="group1"
                                  label={t("Type.label")}
                                  type="checkbox"
                                  id="inline-checkbox-type"
                                  checked={colHideShow.type}
                                  onChange={() => setColHideShow({ ...colHideShow, type: !colHideShow.type })}
                                />
                              </li>
                              <li>
                                <Form.Check
                                  inline
                                  name="group1"
                                  label={t("Unit.label")}
                                  type="checkbox"
                                  id="inline-checkbox-unit"
                                  checked={colHideShow.unit}
                                  onChange={() => setColHideShow({ ...colHideShow, unit: !colHideShow.unit })}
                                />
                              </li>
                              <li>
                                <Form.Check
                                  inline
                                  name="group1"
                                  label={t("PossibleUOMs.label")}
                                  type="checkbox"
                                  id="inline-checkbox-uoms"
                                  checked={colHideShow.possibleUoms}
                                  onChange={() => setColHideShow({ ...colHideShow, possibleUoms: !colHideShow.possibleUoms })}
                                />
                              </li>
                            </ul>
                          </Dropdown.Menu>
                        </Dropdown>
                      </OverlayTrigger>
                      <OverlayTrigger
                        overlay={Utils.renderTooltip(
                          t("Download.label")
                        )}>
                        <button
                          className="btn btn-headbtn"
                          onClick={handleExportToExcel}
                          aria-label={t("Download.label")}
                        >
                          <BiDownload />
                        </button>
                      </OverlayTrigger>
                    </>
                  )}
                  {viewMode === "collapse" && canManageTopicExportImport() && (
                    <>
                      <OverlayTrigger
                        overlay={Utils.renderTooltip(t("Import.label"))}
                      >
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleImportTopicsClick}
                          aria-label={t("Import.label")}
                        >
                          <BiUpload className="me-1" />
                          {t("Import.label")}
                        </button>
                      </OverlayTrigger>
                      <input
                        ref={topicImportFileRef}
                        type="file"
                        className="d-none"
                        accept=".xlsx,.xls"
                        onChange={handleImportTopicsFile}
                      />
                      {selectedTopicIds.length > 0 && (
                        <OverlayTrigger
                          overlay={Utils.renderTooltip(t("Export.label"))}
                        >
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleExportTopics}
                            aria-label={t("Export.label")}
                          >
                            <BiDownload className="me-1" />
                            {t("Export.label")} ({selectedTopicIds.length})
                          </button>
                        </OverlayTrigger>
                      )}
                    </>
                  )}
                  <div className="view-toggle-buttons d-flex align-items-center">
                    <Form.Check
                      inline
                      label={<BsList />}
                      type="radio"
                      id="viewCollapse"
                      name="viewMode"
                      value="collapse"
                      checked={viewMode === "collapse"}
                      onChange={() => {
                        setViewMode("collapse");
                        setShowFilter(false);
                      }}
                    />
                    <Form.Check
                      inline
                      label={<BsTable />}
                      type="radio"
                      id="viewTable"
                      name="viewMode"
                      value="table"
                      checked={viewMode === "table"}
                      onChange={() => setViewMode("table")}
                    />
                  </div>
                  {!isFinalizeInProgress && list?.status !== "DRAFT" && (
                    <OverlayTrigger
                      overlay={Utils.renderTooltip(
                        t("CreateForm.tooltip.label")
                      )}>
                      <button
                        className="btn btn-primary"
                        onClick={() => setShowFinalizeModal(true)}
                      >
                        {t("CreateForm.label")}
                      </button>
                    </OverlayTrigger>
                  )}
                  {list?.status === "DRAFT" && (
                    <button
                      className="btn btn-primary"
                      onClick={(e) => handlePublish(list)}
                    >
                      {t("Publish.label")}
                    </button>
                  )}
                </div>
              </div>
            </li>
          </ul>
        </div>
        <FinalizeProgressLoader isFinalizeInProgress={isFinalizeInProgress} />
        {showFilter && viewMode === "table" && (
          <StandardsFilter
            standardId={glbRegulation?.id}
            initialFilter={currentFilter}
            onApplyFilter={handleFilterApply}
            onFilterHide={setShowFilter}
            onResetFilter={handleFilterReset}
          />
        )}
        <div className={`card-body p-0 ${viewMode === "table" ? "table-view" : "collapse-view"}`}>
          {
            viewMode === "collapse" ?
              <div className="SML_Add_Card_row01">
                <div className="SML_Add_Card_row01_body">
                  <div>
                    <Collapse in={true}>
                      <Topics
                        std_id={glbRegulation.id}
                        isFinalizeInProgress={isFinalizeInProgress}
                        selectedTopicIds={selectedTopicIds}
                        onSelectedTopicIdsChange={setSelectedTopicIds}
                        refreshKey={topicsRefreshKey}
                      />
                    </Collapse>
                    <Collapse in={true}>
                      <CollapsibleGeneralDisclosures />
                    </Collapse>
                  </div>
                </div>
              </div>
              : <TopicsMetricsDpsTable
                data={tableData}
                isLoading={isLoadingTable}
                stdId={glbRegulation?.id}
                currentcategory={currentFilter.category}
                colHideShow={colHideShow}
                isFinalizeInProgress={isFinalizeInProgress}
                onEditTopic={(topicId, stdId, category) => {
                  setShowTopic(true);
                  setStdId(stdId);
                  setEditTopicId(topicId);
                  setCurrentCategory(category);
                }}
                onAddTopic={(stdId, category) => {
                  setShowTopic(true);
                  setStdId(stdId);
                  setEditTopicId("");
                  setCurrentCategory(category);
                }}
                onEditMetric={(metricId, topicId, stdId) => {
                  setShowMetric(true);
                  setStdId(stdId);
                  setTopicId(topicId);
                  setEditMetricId(metricId);
                }}
                onAddMetric={(topicId, stdId) => {
                  setShowMetric(true);
                  setStdId(stdId);
                  setTopicId(topicId);
                  setEditMetricId("");
                }}
                onDeleteMetric={() => {
                  // Refresh table data after metric deletion
                  fetchTableData(currentFilter);
                }}
                onEditDataPoint={(dataPointId, metricId, dataPoint) => {
                  setShowDataPoints(true);
                  setMetricId(metricId);
                  setEditDataPointId(dataPointId);
                  setEditData(dataPoint);
                }}
                onAddDataPoint={(metricId) => {
                  setShowDataPoints(true);
                  setMetricId(metricId);
                  setEditDataPointId("");
                  setEditData(null);
                }}
                onDeleteDataPoint={() => {
                  // Refresh table data after data point deletion
                  fetchTableData(currentFilter);
                }}
                onEquationUpdate={() => {
                  // Refresh table data after equation update
                  fetchTableData(currentFilter);
                }}
                onEmissionLinkUpdate={() => {
                  // Refresh table data after emission link update
                  fetchTableData(currentFilter);
                }}
                onDataSourceLinkUpdate={() => {
                  // Refresh table data after datasource link update
                  fetchTableData(currentFilter);
                }}
                onDeleteTopic={() => {
                  // Refresh table data after topic deletion
                  fetchTableData(currentFilter);
                }}
              />
          }

          {viewMode === "table" ? (
            <>
              <Modal
                show={showTopic}
                onHide={() => handleDiscard(true)}
                size="lg"
                aria-labelledby="add-topic-modal-title"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title id="add-topic-modal-title">
                    {editTopicId ? t("EditTopic.label") : t("AddTopic.label")}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <AddTopic
                    stdId={stdId}
                    handleDiscard={handleDiscard}
                    editTopicId={editTopicId}
                    handleSave={handleAfterSave}
                    currentcategory={currentFilter.category}
                  />
                </Modal.Body>
              </Modal>

              <Modal
                show={showMetric}
                onHide={() => handleMetricDiscard(true)}
                size="lg"
                aria-labelledby="create-metric-modal-title"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title id="create-metric-modal-title">
                    {editMetricId ? `${t("Update.label")} ${t("Metric.label")}` : `${t("Add.label")} ${t("Metric.label")}`}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <CreateMetric
                    stdId={stdId}
                    handleDiscard={handleMetricDiscard}
                    topicId={topicId}
                    editMetricId={editMetricId}
                    handleSave={handleAfterMetricSave}
                  />
                </Modal.Body>
              </Modal>

              <Modal
                show={showDataPoints}
                onHide={() => handleMetricDiscard(true)}
                size="lg"
                aria-labelledby="create-datapoint-modal-title"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title id="create-datapoint-modal-title">
                    {editDataPointId ? `${t("Update.label")} ${t("DataPoint.label")}` : t("NewDP.label")}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <CreateDataPoint
                    handleDiscard={handleMetricDiscard}
                    metricId={metricId}
                    editDataPointId={editDataPointId}
                    handleSave={handleAfterDataPointSave}
                    editData={editdata}
                  />
                </Modal.Body>
              </Modal>
            </>
          ) : (
            <>
              {showTopic &&
                <AddTopic
                  stdId={stdId}
                  handleDiscard={handleDiscard}
                  editTopicId={editTopicId}
                  handleSave={handleAfterSave}
                  currentcategory={currentFilter.category}
                />
              }
              {showMetric &&
                <CreateMetric
                  stdId={stdId}
                  handleDiscard={handleMetricDiscard}
                  topicId={topicId}
                  editMetricId={editMetricId}
                  handleSave={handleAfterMetricSave}
                />
              }
              {showDataPoints &&
                <div>
                  <CreateDataPoint
                    handleDiscard={handleMetricDiscard}
                    metricId={metricId}
                    editDataPointId={editDataPointId}
                    handleSave={handleAfterDataPointSave}
                    editData={editdata}
                  />
                </div>
              }
            </>
          )}

          {openStandardSave &&
            <StandardsCreate
              handleCreateCallback={handleEditCallback}
              editStandard={editStandardItem}
            />
          }

          <FinalizeConfigurationModal
            show={showFinalizeModal}
            onHide={() => setShowFinalizeModal(false)}
            onConfirm={handleFinalizeConfiguration}
          />

          <Modal
            show={showFormCreatedSuccessModal}
            onHide={() => setShowFormCreatedSuccessModal(false)}
            size="sm"
            aria-labelledby="form-created-success-modal-title"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="form-created-success-modal-title">
                {t("FinalizeConfiguration.formCreatedSuccess.title.label")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p className="mb-0">{t("FinalizeConfiguration.formCreatedSuccess.message.label")}</p>
              <p className="mb-0 mt-2">
                {t("FinalizeConfiguration.formCreatedSuccess.gotoForms.label")}{" "}
                <Link to="/company_admin/forms" onClick={() => setShowFormCreatedSuccessModal(false)}>
                  {t("FinalizeConfiguration.formCreatedSuccess.formsList.label")}
                </Link>
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={() => setShowFormCreatedSuccessModal(false)}>
                {t("Ok.label")}
              </Button>
            </Modal.Footer>
          </Modal>

        </div>
      </div >
    </>
  );
};
StandardsMain.propTypes = {};
export default withTranslation()(StandardsMain);
